import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMapMarkerAlt} from "@fortawesome/pro-solid-svg-icons";
import {getCurrencyBadge, navigateToDetailPage} from "../../helpers/common";
import React from "react";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import {useDispatch, useSelector} from "react-redux";
import {getLoginConfig} from "../../redux/slices/loginconfigSlice";
import {getSearchFilters} from "../../redux/slices/searchFilterSlice";
import {useNavigate} from "react-router-dom";
import PropTypes from "prop-types";

export const HotelItemMapCard = ({item}) => {
    const offer_item = item;
    const dispatch = useDispatch();
    const {T} = useTranslationCustom();
    const navigate = useNavigate();
    const loginConfig = useSelector(getLoginConfig);
    const searchfilters = useSelector(getSearchFilters);

    const handleOnClick = () => {
        navigateToDetailPage(
            offer_item,
            dispatch,
            loginConfig,
            searchfilters,
            navigate,
            "hotel",
            null,
            false,
            true,
            null, // Branch data null
        );
    };

    return (
        <div className="packages-card-list">
            <div className="small-card-image-holder">
                <img
                    src={
                        offer_item?.thumbnailUrl ||
                        "https://www.geniustravel.com/background-image-banner.jpg"
                    }
                    className="covered-image"
                    alt={"hotel-image"}
                />
            </div>
            <div className="small-card-content-holder">
                <div>
                    <h4 className="heading heading-6 dark-text font-poppings">
                        {offer_item?.name}
                    </h4>
                    <p className="location">
                        <FontAwesomeIcon icon={faMapMarkerAlt}/>
                        {offer_item?.address}
                    </p>
                </div>
                <div className="price-holder">
                    <div className="price">
                        {`${getCurrencyBadge(offer_item?.perPersonPrice?.currency)} ${offer_item?.perPersonPrice?.totalPrice}`}
                        <span>/p.p</span>
                    </div>
                    <div className="action">
                        <a
                            className="action-btn"
                            onClick={() => handleOnClick()}
                        >
                            {T("Buttons:View")}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

HotelItemMapCard.propTypes = {
    item: PropTypes.object
}

export default HotelItemMapCard;

